var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rp-sidebar-users"},[_c('div',{staticClass:"rp-sidebar-users-header"},[_c('r-search-input',{attrs:{"filter-text":_vm.filterText},on:{"change":e => (_vm.filterText = e)}})],1),(_vm.allUsers)?_c('rp-sidebar-users-list',{attrs:{"users":_vm.allUsers}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }